import { OutsideClick } from "./outside-click";
export * from "./outside-click";
export var OUSTIDE_CLICK_DIRECTIVES = [
    OutsideClick
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/utils/outside-click/index.js
// module id = 313
// module chunks = 4